var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 141,
    viewBox: "0 0 208 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 208,
    height: 140.577,
    rx: 4,
    fill: "#004552"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2856,
    y: 21.1488,
    width: 75.2381,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5161 37.6364H59.5521V46.5894H58.2221V39.2114C57.9887 39.3467 57.7507 39.4517 57.5081 39.5264C57.2654 39.5964 57.0227 39.6361 56.7801 39.6454V38.3574C57.0834 38.3201 57.3774 38.2454 57.6621 38.1334C57.9514 38.0167 58.2361 37.8511 58.5161 37.6364Z",
    fill: "#004552"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.047,
    y: 21.1488,
    width: 75.2381,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2856,
    y: 74.6429,
    width: 48.9048,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.8335,
    y: 74.6429,
    width: 48.9048,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 131.238,
    y: 74.6429,
    width: 48.9048,
    height: 45.3599,
    rx: 4,
    fill: "#E6FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.93 46.5894V45.1824C139.93 44.6737 140.009 44.2467 140.168 43.9014C140.326 43.5514 140.557 43.2597 140.861 43.0264C141.164 42.7931 141.533 42.5924 141.967 42.4244L143.759 41.7244C144.188 41.5517 144.508 41.3324 144.718 41.0664C144.928 40.8004 145.033 40.4714 145.033 40.0794C145.033 39.6734 144.89 39.3374 144.606 39.0714C144.321 38.8054 143.917 38.6724 143.395 38.6724C142.886 38.6724 142.464 38.7891 142.128 39.0224C141.796 39.2511 141.607 39.5941 141.561 40.0514H140.084C140.107 39.4961 140.261 39.0294 140.546 38.6514C140.83 38.2734 141.215 37.9887 141.701 37.7974C142.186 37.6061 142.744 37.5104 143.374 37.5104C143.962 37.5104 144.489 37.6224 144.956 37.8464C145.422 38.0704 145.791 38.3807 146.062 38.7774C146.337 39.1741 146.475 39.6314 146.475 40.1494C146.475 40.6114 146.391 41.0151 146.223 41.3604C146.055 41.7011 145.807 41.9974 145.481 42.2494C145.154 42.5014 144.757 42.7207 144.291 42.9074L142.471 43.6284C142.06 43.7871 141.754 43.9737 141.554 44.1884C141.358 44.3984 141.26 44.6737 141.26 45.0144V45.3644H146.405V46.5894H139.93Z",
    fill: "#004552"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2928 100.265C46.8354 100.265 46.3944 100.202 45.9698 100.076C45.5451 99.9456 45.1624 99.759 44.8218 99.5163C44.4858 99.269 44.2198 98.9633 44.0238 98.5993C43.8278 98.2306 43.7298 97.806 43.7298 97.3253H45.1158C45.1298 97.6893 45.2324 97.9996 45.4238 98.2563C45.6151 98.513 45.8718 98.709 46.1938 98.8443C46.5158 98.975 46.8821 99.0403 47.2928 99.0403C47.9088 99.0403 48.3871 98.8933 48.7278 98.5993C49.0731 98.3053 49.2458 97.9366 49.2458 97.4933C49.2458 97.2086 49.1734 96.959 49.0288 96.7443C48.8888 96.5296 48.6671 96.364 48.3638 96.2473C48.0651 96.126 47.6754 96.0653 47.1948 96.0653H46.1098V95.0153H46.9358C47.5518 95.0153 48.0371 94.8893 48.3918 94.6373C48.7464 94.3806 48.9238 94.033 48.9238 93.5943C48.9238 93.2023 48.7768 92.8733 48.4828 92.6073C48.1888 92.3413 47.7618 92.2083 47.2018 92.2083C46.7584 92.2083 46.3641 92.2993 46.0188 92.4813C45.6734 92.6586 45.4448 92.9783 45.3328 93.4403H43.9538C44.0238 92.8616 44.2058 92.3926 44.4998 92.0333C44.7938 91.674 45.1694 91.4126 45.6268 91.2493C46.0841 91.086 46.5951 91.0043 47.1598 91.0043C47.7711 91.0043 48.3171 91.1093 48.7978 91.3193C49.2831 91.5246 49.6634 91.8116 49.9388 92.1803C50.2141 92.549 50.3518 92.9736 50.3518 93.4543C50.3518 93.9163 50.2211 94.3153 49.9598 94.6513C49.7031 94.9826 49.3274 95.237 48.8328 95.4143C49.3834 95.5823 49.8314 95.8506 50.1768 96.2193C50.5221 96.5833 50.6948 97.0453 50.6948 97.6053C50.6948 98.1233 50.5548 98.583 50.2748 98.9843C49.9948 99.3856 49.6004 99.7006 49.0918 99.9293C48.5831 100.153 47.9834 100.265 47.2928 100.265Z",
    fill: "#004552"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.754 91.0533H104.021V96.8633H105.568V97.9973H104.021V100.083H102.705V97.9973H98.1337V96.9823L102.754 91.0533ZM102.761 93.0833L99.7087 96.9823H102.761V93.0833Z",
    fill: "#004552"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.652 100.265C156.055 100.265 155.518 100.16 155.042 99.9503C154.566 99.7356 154.188 99.4253 153.908 99.0193C153.628 98.6086 153.484 98.1093 153.474 97.5213H154.818C154.818 98.0253 154.993 98.4056 155.343 98.6623C155.698 98.9143 156.134 99.0403 156.652 99.0403C157.231 99.0403 157.693 98.8606 158.038 98.5013C158.384 98.1373 158.556 97.6916 158.556 97.1643C158.556 96.119 157.873 95.5963 156.505 95.5963H153.971L154.37 91.1653H159.487V92.3833H155.441L155.707 91.9633L155.427 94.8683L155.287 94.7353C155.511 94.684 155.77 94.6466 156.064 94.6233C156.358 94.6 156.617 94.5883 156.841 94.5883C157.784 94.5883 158.533 94.8076 159.088 95.2463C159.648 95.6803 159.928 96.3196 159.928 97.1643C159.928 97.7476 159.793 98.275 159.522 98.7463C159.256 99.213 158.878 99.584 158.388 99.8593C157.898 100.13 157.32 100.265 156.652 100.265Z",
    fill: "#004552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight1);
export default __webpack_public_path__ + "static/media/headlight-1.0858fc0a48558214259b90b4069e91de.svg";
export { ForwardRef as ReactComponent };